var React = require('react');

function ArrowShort (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.7932 3.49424C6.7883 8.0804 3.89614 12.6666 3.89614 12.6666C3.89614 12.6666 1.00398 8.0804 0.0235891 3.52138C-0.270529 2.16452 2.32751 3.22287 2.35202 2.70726L2.89648 2.111L3.08732 0.444336L4.70496 0.444336L4.89648 2.111L5.46477 2.68013C5.48928 3.19573 8.08732 2.13739 7.7932 3.49424Z"}));
}

ArrowShort.defaultProps = {"width":"8","height":"13","viewBox":"0 0 8 13","fill":"none"};

module.exports = ArrowShort;

ArrowShort.default = ArrowShort;
